<template>
  <div class="edit-box">
    <MineHeaderView @click-icon="openMenu" />
    <GoBackView />
    <MineMenuView ref="mmv" />
    <div class="frm-area">
      <div class="title">店铺设置</div>
      <div class="frm-box">
        <van-form @submit="onSubmit">
          <div class="frm-item">
            <div class="frm-label">商铺LOGO</div>
            <div style="padding: 16px 16px">
              <van-uploader
                v-model="fileList1"
                multiple
                :after-read="afterRead1"
                :max-count="1"
                :before-read="beforeRead"
                :before-delete="file1Delete1"
              >
              </van-uploader>
              <div v-if="islogo" style="color: #ee0a24; font-size: 12px">
                请上传商铺LOGO
              </div>
            </div>
          </div>
          <div class="frm-item">
            <div class="frm-label">店铺名称</div>
            <van-field
              v-model="frm.name"
              placeholder="请填写您的店铺名称"
              :rules="[{ required: true, message: '请填写您的店铺名称' }]"
            />
          </div>
          <div class="frm-item">
            <div class="frm-label">店铺元标题</div>
            <van-field
              v-model="frm.title"
              placeholder="请填写您的店铺元标题"
              :rules="[{ required: true, message: '请填写您的店铺元标题' }]"
            />
          </div>
          <div class="frm-item">
            <div class="frm-label">店铺元描述</div>
            <van-field
              v-model="frm.bewrite"
              type="textarea"
              placeholder="请填写您的店铺元描述"
              rows="2"
              autosize
              maxlength="150"
              show-word-limit
            />
          </div>
          <div class="btn-box">
            <van-button
              native-type="submit"
              :loading="posting"
              loading-text="提交中..."
              style="background-color: #141423; color: #fff; border-radius: 8px"
              >更新店铺信息</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { getToken } from '@/utils/cookies'
import { MineHeaderView, MineMenuView } from './components/index'
import GoBackView from '@/components/goback/index.vue'
export default {
  name: 'MineSellerView',
  components: { MineHeaderView, MineMenuView, GoBackView },
  data () {
    return {
      posting: false,
      fileList1: [],
      frm: {
        logo: null,
        name: null,
        title: null,
        bewrite: null
      },
      islogo: false
    }
  },
  mounted () {
    this.getshop()
  },
  methods: {
    async getshop () {
      await this.$http({
        method: 'post',
        url: 'getShopInfo'
      }).then(res => {
        if (res && res.data && res.data.shop_info) {
          this.frm.logo = res.data.shop_info.logo
          this.frm.name = res.data.shop_info.name
          this.frm.title = res.data.shop_info.title
          this.frm.bewrite = res.data.shop_info.bewrite
          if (this.frm.logo && this.frm.logo.length > 0) {
            this.fileList1.push({ url: res.data.shop_info.logo })
          }
        }
      })
    },
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    beforeRead (file) {
      this.islogo = false
      const validTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/webp',
        'image/bmp',
        'image/svg+xml',
        'image/apng',
        'image/avif'
      ]
      if (!validTypes.includes(file.type)) {
        this.$toast.fail('请上传图片文件')
        return false
      }
      return true
    },
    async afterRead1 (file) {
      file.status = 'uploading'
      const formData = new FormData()
      formData.append('file', file.file)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'bearer ' + getToken()
        }
      }
      await Axios.post('/api/index/tools.tools/upload', formData, config)
        .then(response => {
          if (response.data.code == 200) {
            file.status = ''
            this.frm.logo = response.data.data.url
          } else {
            file.status = 'failed'
            this.$toast.fail(response.data.msg)
          }
        })
        .catch(error => {
          file.status = 'failed'
          console.log(error)
        })
    },
    file1Delete1 () {
      this.frm.logo = null
      this.fileList1 = []
    },
    async onSubmit () {
      console.log(this.frm)
      if (!(this.frm.logo && this.frm.logo.length)) {
        this.islogo = true
        return false
      }

      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'userseller',
        data: this.frm
      })
        .then(res => {
          this.posting = false
          this.$toast.success(res.msg)
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-box {
  margin: 40px 10px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .frm-area {
    .title {
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      font-weight: 550;
      border-bottom: 1px solid #dcdee0;
    }
    .frm-box {
      margin: 8px 0;
      .frm-label {
        text-indent: 14px;
        font-size: 14px;
        margin-top: 10px;
      }
      .btn-box {
        margin: 16px 0 0;
        text-align: right;
      }
    }
  }
}
</style>
<style lang="scss">
.frm-box {
  .van-uploader__preview-image {
    width: 200px !important;
    height: 124px !important;
  }
}
</style>
